<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card elevation="8" class="text-center pa-8">
          <v-avatar color="success" size="80" class="mb-4">
            <v-icon size="50" color="white">mdi-check-circle</v-icon>
          </v-avatar>
          
          <h2 class="text-h4 font-weight-bold mb-2">Jira Conectado!</h2>
          <p class="text-body-1 grey--text mb-6">
            Sua integração com o Jira foi configurada com sucesso.
          </p>

          <v-btn
            color="success"
            large
            rounded
            @click="fecharJanela"
          >
            <v-icon left>mdi-check</v-icon>
            Fechar
          </v-btn>

          <p class="text-caption grey--text mt-4">
            Esta janela fechará automaticamente em {{ countdown }}s
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'JiraSuccess',

  data: () => ({
    countdown: 5,
    intervalId: null,
  }),

  mounted() {
    console.log('✅ Jira OAuth Success - Integração concluída')
    
    // Countdown para fechar automaticamente
    this.intervalId = setInterval(() => {
      this.countdown--
      if (this.countdown === 0) {
        this.fecharJanela()
      }
    }, 1000)
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },

  methods: {
    fecharJanela() {
      // Tentar fechar a janela popup
      if (window.opener) {
        console.log('🔄 Fechando popup OAuth...')
        window.close()
      } else {
        // Se não for popup, redirecionar para settings
        console.log('↩️ Redirecionando para configurações...')
        this.$router.push('/settings')
      }
    },
  },
}
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
</style>
